//import region
import React from 'react';

// bootstrap
import Form from "react-bootstrap/Form";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectSeasonalVarianceFilter, setSeasonalVarianceFilter } from "_redux/slices/prm-bookings/calendar";

// styling
import { Colors} from "_styles";
//#end region

const SeasonalVarianceToggle = (props) => {

    // redux
    const dispatch = useDispatch();

    // dep pax no shows filter
    const seasonalVarianceFilter = useSelector(selectSeasonalVarianceFilter);

    return (
        <div style={{ display: "flex" }}>
            <Form.Check onClick={(e) => { dispatch(setSeasonalVarianceFilter(e.target.checked));}} type="switch" defaultChecked={seasonalVarianceFilter} />
            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Include Seasonal Variance</Form.Label>
        </div>
    );
};

export default SeasonalVarianceToggle;
